import { Component, Input, OnInit, ViewChild, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { StatsDto } from '@coin/importer/dto/util';
import { BaseChartDirective } from 'ng2-charts';
import { Chart } from 'chart.js';
import { FileTypeService } from '../../services/file-type/file-type.service';
import { DatasetDoughnut } from './dataset-doughnut';
import { Doughnut } from './doughnut';
import { FileTypeDoughnut } from './fileType-doughnut';
import { ValidationsDoughnut } from './validations-doughnut';
import { emptyDoughnutPlugin } from './empty-doughnut-plugin/empty-doughnut-plugin';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'importer-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ChartsComponent implements OnInit {
  private fileTypeService = inject(FileTypeService);

  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;
  @Input() public importStats: StatsDto | undefined;
  @Input() public level: 'datasets' | 'changes' | 'fileTypes';
  public chartData: Doughnut;
  private destroyRef = inject(DestroyRef);

  ngOnInit() {
    Chart.register(emptyDoughnutPlugin);

    switch (this.level) {
      case 'datasets':
        this.chartData = new DatasetDoughnut(this.importStats);
        break;
      case 'changes':
        this.chartData = new ValidationsDoughnut(this.importStats?.validations);
        break;
      case 'fileTypes':
        this.fileTypeService.fileTypeSubject$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
          this.chartData = new FileTypeDoughnut(data);
        });
        break;
    }
  }
}
